<template>
    <v-container fluid>

        <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <NavBar_Gene></NavBar_Gene>
            <Loading v-model:active="isLoading" v-model="fullPage" :can-cancel="true" :is-full-page="fullPage" />
        </span>

                <div id="igvContainer" ref="igvContainer">
                    <table>
                        <tr>
                            <td v-html="this.$store.getters.getProcessState('load-results')"></td>
                        </tr>
                    </table>
                </div>

        <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
                <v-container justify="center" fill-height fluid>

                  <v-row style="text-align: center;">
                    <v-col cols="12" md="12" lg="4" xl="4" style="text-align:center;" v-if="'gencode' in item">
                        <div class="content-box-toolbar-div">
                                        <v-toolbar class="rounded-lg elevation-5" dark color="f5f5f5" style="padding:0;text-align:left;height:40px;" density="compact">
                                             <v-toolbar-title style="font-size:16px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                   Gene Information
                                             </v-toolbar-title>
                                        </v-toolbar>
                        </div>
                        <v-card class="content-box elevation-2" style="padding-left:10px;padding-right:10px;">

                                        <div class="content-box-header-space"></div>
                                        <div>
                                            <v-table>
                                                <tr>
                                                    <td>Chromosome</td>
                                                    <td>{{ item["gencode"]["gene"][0][" seqname"] }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Start-End</td>
                                                    <td>{{ item["gencode"]["gene"][0][" start_pos"] }}-{{ item["gencode"]["gene"][0][" end_pos"] }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Strand</td>
                                                    <td>{{ item["gencode"]["gene"][0][" strand"] }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Ensembl ID</td>
                                                    <td>{{ item["gencode"]["gene"][0]["gene_id"] }}</td>
                                                </tr>
                                                <tr>
                                                    <td>HGNC ID</td>
                                                    <td>{{ item["gencode"]["gene"][0]["hgnc_id"] }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Havana Gene</td>
                                                    <td>{{ item["gencode"]["gene"][0]["havana_gene"] }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Type</td>
                                                    <td>{{ item["gencode"]["gene"][0]["gene_type"] }}</td>
                                                </tr>

                                                <tr v-if="'cosmic' in item">
                                                    <td>Germline</td>
                                                    <td v-if="item.cosmic.length > 0">
                                                        {{ item["cosmic"][0]["GERMLINE"] }}
                                                    </td>
                                                </tr>
                                            </v-table>

                                        </div>
                                        <div style="height:10px;"></div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="12" lg="4" xl="4" style="text-align:center;">
                                    <!-- Gene Descriptions -->
                                     <div class="content-box-toolbar-div">
                                        <v-toolbar class="rounded-lg elevation-5" dark color="f5f5f5" style="padding:0;text-align:left;height:40px;" density="compact">
                                             <v-toolbar-title style="font-size:16px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                   Gene Summary
                                             </v-toolbar-title>
                                        </v-toolbar>
                                     </div>
                                    <v-card class="content-box elevation-2" style="padding-left:10px;padding-right:10px;">

                                        <div class="content-box-header-space"></div>

                                        <v-card-subtitle style="padding-top:10px;">
                                            OncoKB
                                        </v-card-subtitle>
                                        <div>
                                            <p v-if="'oncokb' in item" style="padding:10px;">
                                                <span v-if="'oncokb' in item['oncokb']">
                                                    <span v-if="'geneSummary' in item['oncokb']['oncokb']">
                                                        {{ item.oncokb.oncokb.geneSummary }}
                                                    </span>
                                                </span>
                                            </p>
                                        </div>
                                        <v-card-subtitle style="padding-top:10px;">
                                            CIViC
                                        </v-card-subtitle>
                                        <span v-if="'civic' in item">
                                        <span v-if="'gene_summary' in item.civic">
                                            <span v-if="item.civic.gene_summary.length > 0">
                                            <div>{{ item.civic.gene_summary[0].description }}
                                                <p v-if="'civic' in item" style="padding:10px;">
                                                    <span v-if="'civic' in item['civic']">
                                                        <span v-if="'gene_summary' in item['civic']['civic']">
                                                            <span v-if="item['civic']['civic']['gene_summary'].length > 0">
                                                                {{ item.civic.civic.gene_summary[0].description }}
                                                            </span>
                                                        </span>
                                                    </span>
                                                </p>
                                            </div>
                                            </span>
                                       </span>
                                       </span>

                                             <div v-if="'gencode' in item">
                                                 <a style=""
                                                    v-bind:href="'https://www.genecards.org/cgi-bin/carddisp.pl?gene='+item.gencode.gene[0].gene_name">
                                                    Show GeneCards entry ({{ item.gencode.gene[0].gene_name }})
                                                 </a>
                                             </div>
                                             <div style="height:20px;"></div>

                                    </v-card>



                    </v-col>
                    <v-col>

                    </v-col>
                </v-row>
                <v-row>
                    <v-col>

                    </v-col>
                </v-row>
                </v-container>
        </span>
    </v-container>
</template>
<script>
import Loading from 'vue-loading-overlay';
import active_variants from "@/methods/active_variants";
import NavBar_Gene from "@/components/navbars/NavBar_Gene";
import ProteinSequence from "@/components/basic_components/ProteinSequence"
import igv_browser from "@/methods/igv_browser";

export default {
    name: 'VariantProtein',
    props: {
    },
    components: {
        Loading,
        NavBar_Gene,
        ProteinSequence
        //Basic: applyReactInVue(SeqViz)
    },
    data: function() {
        return {
            isLoading: false,
            fullPage: true,
            vcfContent: '',
            active_chrom : '',
        }
    },
    computed: {
        active_biomarker() {
            return this.$store.getters.getActiveBiomarker
        }
    },
    watch: {
        // whenever question changes, this function will run
        active_biomarker(newActiveBiomarker, oldActiveBiomarker) {
          //if (newActiveBiomarker.includes('?')) {
          //  alert("biomarker loaded")
          //}
        }
    },
    methods: {
        pos_formatted(pos_start) {
                    var splitString = String(pos_start).split("");

                    var reverseArray = splitString.reverse();
                    let reverseArraytoStr = ''
                    for (let i=0; i<reverseArray.length; i +=1) {
                        reverseArraytoStr += reverseArray[i]
                    }
                    //alert(reverseArraytoStr)
                    const result = reverseArraytoStr.match(/.{1,3}/g) || [];

                    let result_str = ''
                    for (let i=0; i<result.length; i +=1) {
                        result_str += result[i] + ','
                    }
                    result_str = this.rtrim(result_str,',')
                    //alert(result_str)

                    let result_arr = result_str.split("").reverse()
                    let result_splitted = ''
                    for (let i=0; i<result_arr.length; i +=1) {
                        result_splitted += result_arr[i]
                    }
                    result_splitted = this.ltrim(result_splitted,',')
                    return result_splitted
        },
        ltrim(x, characters) {
          var start = 0;
          while (characters.indexOf(x[start]) >= 0) {
            start += 1;
          }
          var end = x.length - 1;
          return x.substr(start);
        },
        rtrim(x, characters) {
          var start = 0;
          var end = x.length - 1;
          while (characters.indexOf(x[end]) >= 0) {
            end -= 1;
          }
          return x.substr(0, end + 1);
        },

    },
    created: async function() {
        //alert(this.$route.fullPath)

        this.isLoading=true
        this.$store.dispatch('setProcessState', [  "load-results",'<table><tr><td><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></td></tr><tr><td>Loading...</td></tr></table>' ] )

        await active_variants.loadActiveBiomarkerGene(this.$route.params.id)
        this.isLoading=false
        //alert(JSON.stringify(this.$store.getters.getActiveBiomarker))

        for (const [key,item] of Object.entries(this.$store.getters.getActiveBiomarker)) {

            if ("gencode" in item) {
                let pos_start = parseInt( item.gencode.gene[0][" start_pos"] ) -20
                let pos_end = parseInt( item.gencode.gene[0][" end_pos"] ) + 20
                let chrom = item["gencode"]["gene"][0][" seqname"]
                //alert(pos_start)

                //let pos_start = parseInt(pos) -20
                //let pos_end = parseInt(pos) + 20
                let result_start = this.pos_formatted(pos_start)
                let result_end = this.pos_formatted(pos_end)
                this.active_chrom = chrom + ':' + result_start + "-" + result_end

                //let cont = '##fileformat=VCFv4.1\nchr' + chrom + '\t' + pos_start + '\t.\t'+ ref +'\t' + alt + '\t.\t.\t.\n'
                //alert(cont)
                //alert("Positions: "+pos_start+"-"+pos_end)

                let date = new Date(2023, 1, 1)
                //this.vcfContent = new File([cont],'sample.vcf', {type: "text/plain", lastModified: date})
                await igv_browser.initializeIGVBrowser(this.$refs.igvContainer,this.active_chrom)

                let activeBiomarker = this.$store.getters.getActiveBiomarker
                activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]

            }
        }
        this.isLoading = false
        this.$store.dispatch('setProcessState', [  "load-results",'' ] )


    }
}
</script>
<style>
.bground-main {
    background-color: #ffffff;
}
.content-box {
    margin-left:0px;
    text-align: left;
    padding:20px;
}
.content-box-title {
}
.content-box-header-space {
  height:40px;
}
.content-box-toolbar-div {
  margin:auto;width:90%;position:relative; top:20px;z-index:10;
}
</style>
